/* eslint-disable no-unused-vars */
import { axios } from '@/repositories'

const resource = '/v1/stay'

export default {
  async getOrderListHistory(menuNm, startIndex, count, reserveSts) {
    // 10170243
    return new Promise((resolve, reject) => {
      const params = {
        menuNm,
        startIndex,
        count,
        reserveSts
      }
      axios
        .get(`${resource}/order/order-list-page`, { params })
        .then((response) => {
          resolve(response.data)
        })
        .catch((error) => {
          reject(error?.error)
        })
    })
  },

  async addFavorite(data) {
    data.serviceType = data.serviceType || 'stay'
    return new Promise((resolve, reject) => {
      axios.post(`${resource}/menu-item-info`, data).then(
        (res) => {
          resolve(res.data)
        },
        (error) => {
          reject(error.error)
        }
      )
    })
  },

  async getOrdersHistory(menuNm, startIndex, count, reserveSts) {
    const params = {
      menuNm,
      startIndex,
      count,
      reserveSts
    }
    return new Promise((resolve, reject) => {
      axios.get(`${resource}/order/order-list-page`, { params }).then(
        (response) => {
          resolve(response.data)
        },
        (error) => {
          reject(error?.error)
        }
      )
    })
  },

  async getPointHistory(pointFrom, pointTo, startIndex, count, commandType) {
    let params = {
      pointFrom,
      pointTo,
      startIndex,
      count,
      commandType
    }
    if (!pointFrom && pointTo) {
      params = {
        pointTo,
        startIndex,
        count,
        commandType
      }
    }
    if (!pointTo && pointFrom) {
      params = {
        pointFrom,
        startIndex,
        count,
        commandType
      }
    }
    if (!pointTo && !pointFrom) {
      params = {
        startIndex,
        count,
        commandType
      }
    }
    if (!commandType && pointFrom && pointTo) {
      params = {
        pointFrom,
        pointTo,
        startIndex,
        count
      }
    }
    if (!commandType && !pointFrom && !pointTo) {
      params = {
        startIndex,
        count
      }
    }
    return new Promise((resolve, reject) => {
      axios.get(`${resource}/member/point/history`, { params }).then(
        (response) => {
          resolve(response.data)
        },
        (error) => {
          reject(error?.error)
        }
      )
    })
  },

  async getFavoriteList(itemType, page, size, sort) {
    const params = {
      itemType,
      page,
      size,
      sort
    }
    return new Promise((resolve, reject) => {
      axios.get(`${resource}/menu-item-info`, { params }).then(
        (response) => {
          resolve(response.data)
        },
        (error) => {
          reject(error?.error)
        }
      )
    })
  },

  async getStatusFavorite(menuNo, type) {
    const serviceType = type ? type : 'stay'
    const params = {
      menuNo,
      serviceType
    }

    return new Promise((resolve, reject) => {
      axios.get(`${resource}/menu/favourite`, { params }).then(
        (response) => {
          resolve(response.data)
        },
        (error) => {
          reject(error?.error)
        }
      )
    })
  },

  async deleteFavorite(menuNo) {
    return new Promise((resolve, reject) => {
      axios.delete(`${resource}/menu-item-info/${menuNo}`).then(
        (response) => {
          resolve(response)
        },
        (error) => {
          reject(error?.error)
        }
      )
    })
  },
  // get view list history
  async getViewedListHistory(itemType, page, size, sort) {
    // 10170243
    return new Promise((resolve, reject) => {
      const params = {
        itemType,
        page,
        size,
        sort
      }
      axios
        .get(`${resource}/menu-item-info`, { params })
        .then(
          (response) => {
            resolve(response.data)
          },
          (error) => {
            reject(error?.error)
          }
        )
        .catch(() => {})
    })
  },
  // remove a item in view list
  async removeItemInList(id) {
    // 10170243
    return new Promise((resolve, reject) => {
      axios
        .delete(`${resource}/menu-item-info/${id}`)
        .then(
          (response) => {
            resolve(response.data)
          },
          (error) => {
            reject(error?.error)
          }
        )
        .catch(() => {})
    })
  }
}
